import { useMemo } from "react";
import { base64ToBlob } from "@/shared/files/base64-to-downloadable-file";
import QrCode from "@/shared/data-display/qr-code";

export function QrFromBase64({ qrCode }: { qrCode?: string }) {
  const src = useMemo(() => {
    if (qrCode) {
      return URL.createObjectURL(base64ToBlob(qrCode, "image/png"));
    }
  }, [qrCode]);

  return (
    <div>
      {src ? (
        <img src={src} alt="QR" />
      ) : (
        <QrCode className={"!size-full"} value={"loading"} />
      )}
    </div>
  );
}
